export default [
  { id: "DEBITO", title: "DEBITO" },
  { id: "CREDITO", title: "CREDITO" },
];
